import { profileActions } from './profile.actions';
import { profileRuleset } from './profile.ruleset';
import { profileState } from './profile.state';
import { profileProperties } from './profile.properties';
import { SB } from '@play-co/replicant';

export namespace Profile {
  export const schema = profileState;
  export const actions = profileActions;
  export const ruleset = profileRuleset;
  export const properties = profileProperties;
}

export type ProfileSlice = typeof Profile;
export type ProfileState = SB.ExtractType<SB.ObjectSchema<typeof profileState>>;
